import style from "./ChangePasswordForm.module.css";

import { useFormWithValidation } from "@/features/forms/hooks/useFormWithValidation";
import { FormProvider } from "react-hook-form";
import { successToast } from "@/ui/toast/Toast";
import Button from "@/ui/button/Button";

import Icon from "@/ui/icon/Icon";

import SettingSection from "../settingsSection/SettingsSection";

import InputPassword from "@/features/forms/components/InputPassword";
import { useChangePassword } from "@/features/auth/hooks/useChangePassword";
import i18n from "@/i18n";
import { useTranslation } from "react-i18next";

export default function ChangePasswordForm({ user }) {
	const { t } = useTranslation();
	const formMethods = useFormWithValidation();

	const {
		handleSubmit,
		setValue,
		formState: { isSubmitting },
	} = formMethods;

	const { save } = useChangePassword();

	const onSubmit = async (data) => {
		await save(data);
		setValue("new_password1", "");
		setValue("new_password2", "");
		successToast(i18n.t("settings:password.saved"));
	};

	return (
		<FormProvider {...formMethods}>
			<form onSubmit={handleSubmit(onSubmit)}>
				<SettingSection
					title={t("settings:password.title")}
					description={t("settings:password.description")}
				>
					<InputPassword
						name="new_password1"
						placeholder={t("common:fields.password.placeholder")}
						label={t("settings:password.newLabel")}
						required={true}
					/>
					<InputPassword
						name="new_password2"
						placeholder={t("common:fields.password.placeholder")}
						label={t("common:fields.confirmPassword.label")}
						required={true}
					/>
				</SettingSection>

				<div className={style.btnHolder}>
					<Button
						className={style.btn}
						type="accent"
						disabled={isSubmitting}
					>
						<Icon icon="fa-floppy-disk" />
						{isSubmitting ? (
							<Icon icon="fa-ellipsis" />
						) : (
							t("common:actions.save")
						)}
					</Button>
				</div>
			</form>
		</FormProvider>
	);
}
